import { Box, Button, Grid2, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step2 = ({ sra, setSra, setStep, storedUser }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.structure)) {
      newErrors.structure = "Detailed Scheme Structure is required";
    } else if (data.structure.length > 1000) {
      newErrors.structure =
        "Detailed Scheme Structure should be up to 1000 characters";
    }

    // Start Date
    if (!data.startDate) {
      newErrors.startDate = "Execution Start Date is required";
    }

    // End Date
    if (!data.endDate) {
      newErrors.endDate = "Execution End Date is required";
    }

    if (data.startDate && data.endDate) {
      const start = new Date(data.startDate);
      const end = new Date(data.endDate);

      if (end <= start) {
        newErrors.endDate = "End Date must be after Start Date";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft-trade?draftSraId=${sra.draftTradeId}`,
        {
          structure: sra.structure,
          startDate: sra.startDate,
          endDate: sra.endDate,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/approval/dashboard/create-trade/draft/${sra.draftTradeId}`)
    setStep((prev) => prev - 1);
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Trade Marketing Scheme</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "40%" }}></span>
      </div>
      <div className="dashboard-container">
        <Box>
          <Typography className="form-title">Justification</Typography>
          <label htmlFor="structure">
            Detailed Scheme Structure{" "}
            <span style={{ color: "#FF0000" }}>*</span>
          </label>
          <textarea
            className={`${errors.structure && "input-error"}`}
            name="structure"
            id="structure"
            rows={4}
            value={sra && sra.structure}
            onChange={handleChange}
            maxLength={1000}
          ></textarea>
          {errors.structure && <p className="error">{errors.structure}</p>}

          <Grid2 container columnSpacing={2}>
            {/* Execution Start Date */}
            <Grid2 size={{ xs: 12, sm: 4 }}>
              <label htmlFor="startDate">
                Execution Start Date <span style={{ color: "#FF0000" }}>*</span>
              </label>
              <input
                className={`${errors.startDate && "input-error"}`}
                type="date"
                name="startDate"
                id="startDate"
                onChange={handleChange}
                value={
                  sra?.startDate
                    ? new Date(sra.startDate).toISOString().split("T")[0]
                    : ""
                }
              />
              {errors.startDate && <p className="error">{errors.startDate}</p>}
            </Grid2>

            {/* Execution End Date */}
            <Grid2 size={{ xs: 12, sm: 4 }}>
              <label htmlFor="endDate">
                Execution End Date <span style={{ color: "#FF0000" }}>*</span>
              </label>
              <input
                className={`${errors.endDate && "input-error"}`}
                type="date"
                name="endDate"
                id="endDate"
                onChange={handleChange}
                value={
                  sra?.endDate
                    ? new Date(sra.endDate).toISOString().split("T")[0]
                    : ""
                }
              />
              {errors.endDate && <p className="error">{errors.endDate}</p>}
            </Grid2>
          </Grid2>
        </Box>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step2;
